import gql from 'graphql-tag';
export const CREATE_REGION = gql`
  
mutation createRegion($input: CreateRegionInput!) {
  createRegion(input: $input) {
    value       
    }
  }
`;
